import * as React from "react";
import { cn } from "../../lib/utils";

type ButtonVariant = "default" | "secondary" | "ghost";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  isLoading?: boolean;
}

const variantClass: Record<ButtonVariant, string> = {
  default: "btn btn-primary",
  secondary: "btn btn-secondary",
  ghost: "btn btn-ghost",
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", isLoading, disabled, children, ...props }, ref) => (
    <button
      ref={ref}
      disabled={disabled || isLoading}
      className={cn(
        variantClass[variant],
        "relative flex items-center justify-center transition-all active:scale-[0.98]",
        (disabled || isLoading) && "opacity-60 cursor-not-allowed grayscale-[0.2]",
        className
      )}
      {...props}
    >
      <span className={cn(isLoading && "opacity-0 invisible")}>{children}</span>
      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
        </span>
      )}
    </button>
  ),
);

Button.displayName = "Button";

export { Button };
